<template>
  <Highcharts ref="highcharts" :options="options" />
</template>

<script>
import Highcharts from '@@/common/stats/Highcharts';

export default {
  name: '',
  components: {
    Highcharts,
  },
  props: {
    impressionCounts: {
      type: Array,
      required: true,
    },
    conversionRates: {
      type: Array,
      required: true,
    },
    dates: {
      type: Array,
      required: true,
    },
    chartsVisibility: {
      type: Object,
      required: true,
    },
    seriesColors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    series() {
      return [
        {
          yAxis: 1,
          name: 'Impression Count',
          data: this.impressionCounts,
        },
        {
          name: 'Conversion Rate',
          data: this.conversionRates,
        },
      ];
    },
    options() {
      return {
        chart: {
          height: '200',
        },
        xAxis: {
          categories: this.dates,
        },
        colors: this.seriesColors,
        yAxis: [
          {
            labels: {
              style: {
                color: this.seriesColors[1],
              },
              format: '{value}%',
            },
            title: false,
          },
          {
            title: false,
            labels: {
              style: {
                color: this.seriesColors[0],
              },
            },
            opposite: true,
          },
        ],
        legend: false,
        title: false,
        series: this.series,
      };
    },
  },
  watch: {
    chartsVisibility: {
      deep: true,
      handler() {
        const {
          highcharts: { chart },
        } = this.$refs;

        Object.values(this.chartsVisibility).forEach((isVisible, index) => {
          if (isVisible) {
            chart.series[index].show();
            return;
          }
          chart.series[index].hide();
        });
      },
    },
  },
};
</script>
